module.exports = __webpack_public_path__ + "img/back-end.a437a5aa.png";